// 小米锁屏：
// "pt-br-mils.comfortweather.com" 巴西葡萄牙语
// "pt-mils.comfortweather.com" 葡萄牙语
// "es-mils.comfortweather.com" 西班牙语
// "arabic-mils.comfortweather.com" 阿拉伯语
// "tr-mils.comfortweather.com" 土耳其语
// "fr-mils.comfortweather.com" 法语
// "it-mils.comfortweather.com" 意大利语
// "urdu-mils.comfortweather.com" 乌尔都语
// "vi-mils.comfortweather.com" 越南语
// "th-mils.comfortweather.com" 泰语
// "en-mils.comfortweather.com" 英语
// "jp-mils.comfortweather.com" 日语
// "ger-mils.comfortweather.com" 德语
// "po-mils.comfortweather.com" 波兰语
// "id-mils.comfortweather.com" 印尼语

// 小米负一屏go机型：
// 'en-miwg.comfortweather.com' 英语
// 'hi-miwg.comfortweather.com' 印地语
// 'id-miwg.comfortweather.com' 印尼语

// 小米负一屏小部件：
// 'en-wg.comfortweather.com' 英语
// 'hi-wg.comfortweather.com' 印地语
// 'id-wg.comfortweather.com' 印尼语
// 'es-wg.comfortweather.com' 西班牙语
// 'en-mxwg.comfortweather.com' 美国
// 'es-mxwg.comfortweather.com' 墨西哥

// vivo锁屏：
// id-v-ls.comfortweather.com 印尼语
// vi-v-ls.comfortweather.com 越南语
// th-v-ls.comfortweather.com 泰语
// hi-v-ls.comfortweather.com 印地语
// en-v-ls.comfortweather.com 英语

import initRum from "@elastic/apm-rum";
try {
  function getServerUrl(countryCode: string): string {
    const europeanCountries = [
      "AL",
      "AD",
      "AM",
      "AT",
      "AZ",
      "BA",
      "BE",
      "BG",
      "BY",
      "CH",
      "CY",
      "CZ",
      "DE",
      "DK",
      "EE",
      "ES",
      "FI",
      "FR",
      "GE",
      "GI",
      "GR",
      "HR",
      "HU",
      "IE",
      "IS",
      "IT",
      "KZ",
      "LI",
      "LT",
      "LU",
      "LV",
      "MC",
      "MD",
      "ME",
      "MK",
      "MT",
      "NL",
      "NO",
      "PL",
      "PT",
      "RO",
      "RS",
      "RU",
      "SE",
      "SI",
      "SK",
      "SM",
      "TR",
      "UA",
      "VA",
    ];
    switch (countryCode) {
      case "IN":
        return "https://apm-rum-ind.inf.miui.com";
      case "RU":
        return "https://apm-rum-ru.inf.miui.com";
      default:
        return europeanCountries.includes(countryCode)
          ? "https://apm-rum-eu.inf.miui.com"
          : "https://apm-rum-sgp.inf.miui.com";
    }
  }
  const local_awsCon = LocalStorage.getItem("awsCon");
  const countryCode = new URLSearchParams(window.location.search).get("r") || local_awsCon || "default";
  const serverConUrl = getServerUrl(countryCode);
  const hostname = window.location.hostname;
  // 目前：
  // 锁屏文章：cp-shengbo-wallpaper-h5
  // 锁屏天气：cp-shengbo-wallpaper-h5
  // 负一屏天气：cp-shengbo-weather-h5
  // 期望：
  // 锁屏文章：cp-shengbo-wallpaper-h5
  // 锁屏天气：cp-shengbo-wallpaper-weather-h5
  // 负一屏天气：cp-shengbo-weather-h5
  const apm = initRum({
    // 小米锁屏和负一屏有不同的事件id: cp-shengbo-weather-h5 和 cp-shengbo-weather-h5
    serviceName: domainMap["mils"].includes(hostname)
      ? "cp-shengbo-wallpaper-weather-h5"
      : [...domainMap["wg"], ...domainMap["miwg"]].includes(hostname)
      ? "cp-shengbo-weather-h5"
      : "cp-shengbo-wallpaper-weather-h5",
    serverUrl: serverConUrl,
    // @ts-ignore
    serviceVersion: __APP_TAG_VERSION__,
    environment: !isDevEnv ? "production" : "develop",
    active: !isDevEnv,
  });
  apm.addLabels({ group: "global-miui-fe-cp" });
} catch (error) {}
